// dependencies.
import styled from 'styled-components'
// components.
import { Body } from '../Typography'
import { Input } from '../Form'
// utils.
import { useDimensions } from '../../js/hooks'

/************************/
/*                      */
/*    Search Heading    */
/*                      */
/************************/

// partials.
const Wrapper = styled.div({
  display: 'flex',
  flexDirection: (props) => (props.column ? 'column' : 'row'),
  gap: (props) => (props.isTablet ? '8px' : '16px'),
  width: (props) => (props.column ? '100%' : 'fit-content'),
})

const mapValueToIndex = (value) => {
  switch (value) {
    case 'Sin Fecha Compromiso':
      return 0
    case 'Con Retraso':
      return 1
    case 'A tiempo':
      return 2
    default:
      return null // Valor por defecto si no se encuentra
  }
}

// main component.
const FilterOtif = ({ label, onOtStatusFilter = () => {}, placeholder = 'OTIF Status' }) => {
  // contexts.
  // hooks.
  const { isMobile, isTablet } = useDimensions()

  const statusOptions = ['Sin Fecha Compromiso', 'Con Retraso', 'A tiempo']

  const optionLabels = statusOptions.map((label, i) => ({ value: i, label }))

  // ------------------------------------------------------------------------------------------- //
  // CONTENT                                                                                     //
  // ------------------------------------------------------------------------------------------- //
  // return content.
  return (
    <Wrapper column={!!label} isTablet={isTablet}>
      {label && (
        <Body type="caption" color="grey">
          {label}
        </Body>
      )}
      <Input
        isMobile={isMobile}
        options={optionLabels}
        name="otifstatus"
        iconL="bookmark"
        placeholder={placeholder}
        onChange={(e) => onOtStatusFilter(mapValueToIndex(e))}
      />
    </Wrapper>
  )
}

export default FilterOtif
